import { parse } from 'papaparse'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { commercialApi } from '@/interfaces/spark-api'
import type { components } from '#/types/capi-generated'

export const useGasStore = defineStore('gas', () => {
  const hasGasPermission = ref(false)

  function parseCsv(csv: string): { columns: string[]; rows: string[][] } {
    const { data, meta, errors } = parse<Record<string, string>>(csv, {
      header: true,
      delimiter: ',',
      skipEmptyLines: true,
    })

    if (errors.length > 0) {
      console.error('CSV parse errors:', errors)
    }

    const columns = meta.fields ?? []
    const rows = data
      .map((item) => Object.values(item))
      .filter((item) => item.length === columns.length)

    return { columns, rows }
  }

  async function fetchGasContracts(
    ticker: components['schemas']['GasContractsViewTickerEnum'],
    unit: components['schemas']['CAPIGasContractsUnitEnum'],
    start?: string,
    end?: string,
    limit?: number,
    offset?: number,
  ): Promise<{
    columns: string[]
    rows: string[][]
  }> {
    try {
      const csv = await commercialApi.fetchGasContracts(
        ticker,
        unit,
        start,
        end,
        limit,
        offset,
      )

      hasGasPermission.value = true
      return parseCsv(csv)
    } catch (err) {
      hasGasPermission.value = false
      console.warn('fetchGasContracts failed', { ticker, unit, start, end, err })
      return { columns: [], rows: [] }
    }
  }

  return {
    hasGasPermission,
    fetchGasContracts,
  }
})
